'use client';

import { useRef, type ReactNode } from 'react';
import { useScrollReveal } from '@/hooks/useScrollReveal';

/**
 * Thin client wrapper that applies scroll-reveal animations to a section.
 * Add className="scroll-reveal" or "scroll-reveal-stagger" for the desired effect.
 */
export function ScrollRevealSection({
  children,
  className = 'scroll-reveal',
  as: Tag = 'div',
  ...props
}: {
  children: ReactNode;
  className?: string;
  as?: 'div' | 'section';
} & React.HTMLAttributes<HTMLElement>) {
  const ref = useRef<HTMLDivElement>(null);
  useScrollReveal(ref);

  return (
    <Tag ref={ref as React.RefObject<HTMLDivElement>} className={className} {...props}>
      {children}
    </Tag>
  );
}
